import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Last segment of a dotted translation key (e.g. boyfriend_attr.personality.romantic → romantic). */
export function translationKeyLastSegment(key: string | null | undefined): string {
  if (!key) return ""
  const parts = key.split(".")
  return parts.length > 0 ? parts[parts.length - 1]! : key
}
